import React, { Fragment, } from 'react'
import './style.css'
export default function Introduce(props) {
    const { data } = props;
    return (
        <div className='GuideCarousel_Introduce'>
            <div className='GuideCarousel_IntroduceLeft'>
                <img className='GuideCarousel_IntroduceImg' src={data.image}/>
                {/*<div className='GuideCarousel_IntroduceTitle'>{data.precedent}</div>*/}
            </div>
            {/* <div className='GuideCarousel_IntroduceContent'>{data.content}</div> */}
            <div className='GuideCarousel_IntroduceRight'>
                <div className='GuideCarousel_IntroduceRightTitle'>{data.title}</div>
                <div className='GuideCarousel_IntroduceRightTitleBottom'/>
                <div className='GuideCarousel_IntroduceRightContent'>{data.content}</div>
            </div>
        </div>
    )
}